import { getSdk, sdkOpts } from "@ihr-radioedit/inferno-core";

const sdk = getSdk(sdkOpts());

export async function getCoastHosts() {
  return sdk!.GetCoastHosts.queryAsPromise({}).then(res => {
    return res.data?.pws?.coastAppContent?.host?.list?.items ?? [];
  });
}

export async function getCoastTopics() {
  return sdk!.GetCoastTopics.queryAsPromise({}).then(res => {
    return res.data?.pws?.coastAppContent?.topics?.results ?? [];
  });
}
